import * as Lambda from '../../services/LambdaApi';
import { FacilityQuestion } from '../types/Survey';

const listFacilityQuestions = async (facilityId: string): Promise<FacilityQuestion[]> => {
    try {
        const apiPath = `/s2l/${facilityId}/listFacilityQuestions`;
        const response = await Lambda.Post(apiPath, { isSelected: true }, 'lambda');
        if (!response?.Result?.Success) {
            throw new Error(response?.Result?.Error || 'Error fetching survey questions');
        }
        const content = response.Result.Content as { Result?: FacilityQuestion[] };
        return content?.Result ?? [];
    } catch (err) {
        throw new Error(err instanceof Error ? err.message : 'Error fetching survey questions');
    }
};

const addResidentAnswer = async (
    facilityId: string,
    payload: { question: string; residentId: string; response: string }
) => {
    try {
        const apiPath = `/s2l/${facilityId}/addResidentAnswer`;
        const response = await Lambda.Post(apiPath, payload, 'lambda');
        if (!response?.Result?.Success) {
            throw new Error(response?.Result?.Error || 'Error submitting answer');
        }
    } catch (err) {
        throw new Error(err instanceof Error ? err.message : 'Error submitting answer');
    }
};

export { listFacilityQuestions, addResidentAnswer };
